import { ComponentPropsWithoutRef } from 'react';

import { Media } from '../../interfaces/cms';
import { getMediaUrl } from '../../utils/mediaUtils';

export type ImageMediaProps = ComponentPropsWithoutRef<'img'> & {
  media?: number | Media | null;
};

export const ImageMedia = ({ media, sizes, ...props }: ImageMediaProps) => {
  // handle unpopulated CMS fields
  if (typeof media === 'number' || !media) {
    return null;
  }

  const srcSet = media.sizes
    ? Object.values(media.sizes)
        .flatMap((size) => {
          if (!(size.url && size.filename && size.width)) {
            return [];
          }

          const url = getMediaUrl(size);

          if (!url) {
            return [];
          }

          return `${encodeURI(url)} ${size.width}w`;
        })
        .join(', ')
    : '';

  return (
    <img
      src={getMediaUrl(media)}
      srcSet={srcSet}
      sizes={sizes ?? '100vw'}
      alt={media.alt ?? undefined}
      width={media.width ?? undefined}
      height={media.height ?? undefined}
      {...props}
    />
  );
};
